import { render, staticRenderFns } from "./VersionModal.vue?vue&type=template&id=6fa9c360&scoped=true"
import script from "./VersionModal.vue?vue&type=script&lang=js"
export * from "./VersionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa9c360",
  null
  
)

export default component.exports